<div [ngClass]="infoStatus[status].class">
  <i *ngIf="infoStatus[status].icon" [ngClass]="infoStatus[status].icon"></i>
  <span>{{ infoStatus[status].title | translate}}</span>
  <span>{{ infoStatus[status].description | translate }}</span>
</div>
